// extracted by mini-css-extract-plugin
export default {"container":"Home_container__PC8+D","puntaCompradoraButton":"Home_puntaCompradoraButton__9JBW4"};